<template>
  <component
    :is="Component"
    :type="type"
    :disabled="disabled"
    :class="{
      'btn rounded-full disabled:bg-transparent py-3 h-auto disabled:text-brand-quaternary-40 min-h-11':
        variant !== 'icon',
      'btn-outline border-brand-primary text-brand-primary disabled:border-brand-quaternary-40':
        variant === 'outlined',
      'bg-brand-bgdivider-10 border-0 text-brand-primary': variant === 'filled',
      'btn-ghost text-basics-tertiary-60 normal-case': variant === 'ghost',
      'btn btn-sm bg-brand-bgdivider-20 text-brand-primary': variant === 'icon',
    }"
    :href="href"
    @click="onClick"
  >
    <template v-if="variant === 'icon'">
      <span v-if="isLoading" class="loading text-brand-primary w-3 h-3"></span>

      <slot />
    </template>

    <template v-else>
      <span v-if="isLoading" class="loading loading-spinner loading-xs" />
      <slot />
    </template>

    <span v-if="caret">
      <Icon icon="mdi:caret" class="rotate-90 text-lg" />
    </span>
  </component>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { Icon } from "@iconify/vue";

const emit = defineEmits<{
  click: [event: MouseEvent];
}>();
const props = defineProps<{
  variant?: "filled" | "outlined" | "ghost" | "icon";
  icon?: string;
  type?: HTMLButtonElement["type"];
  caret?: boolean;
  href?: string;
  disabled?: boolean;
  isLoading?: boolean;
}>();

const Component = computed(() => (props.href ? "a" : "button"));
const variant = computed(() => props.variant ?? "filled");
const disabled = computed(() => props.disabled || undefined);

function onClick(event: MouseEvent) {
  emit("click", event);
}
</script>
